module.exports = __webpack_public_path__ + "media/images/writer/community/pc-headline-about-rule@3x-2084dc22d5b23ecd538807bbae6f2159.png";